/**
 * Add your config changes here.
 * @module config
 * @example
 * export default function applyConfig(config) {
 *   config.settings = {
 *     ...config.settings,
 *     port: 4300,
 *     listBlockTypes: {
 *       ...config.settings.listBlockTypes,
 *       'my-list-item',
 *    }
 * }
 */

// All your imports required for the config here BEFORE this line
import '@plone/volto/config';
import BlogDocumentView from './components/Blog/BlogDocumentView';
import SiteHomeView from './components/Blog/SiteHomeView';

export default function applyConfig(config) {
  config.settings = {
    ...config.settings,
    isMultilingual: false,
    supportedLanguages: ['ja'],
    defaultLanguage: 'ja',
  };
  config.views = {
    ...config.views,
    layoutViews: {
      ...config.views.layoutViews,
      document_view: BlogDocumentView,
    },
    contentTypesViews: {
      ...config.views.contentTypesViews,
      Document: BlogDocumentView,
      'Plone Site': SiteHomeView,
    },
  };
  return config;
}
